import { SvgIcon, Toolbar } from '@mui/material';
import { ReactComponent as MiniLogo } from 'atoms/icons/svg/mini-logo.svg';
import { ReactComponent as Logo } from 'atoms/icons/svg/remora-logo-black.svg';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  isExpanded: boolean;
};

const MenuLogo: FC<Props> = ({ isExpanded }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/dashboard');
  };

  return (
    <Toolbar disableGutters style={{ alignSelf: 'center' }}>
      <SvgIcon
        component={isExpanded ? Logo : MiniLogo}
        inheritViewBox
        onClick={handleClick}
        style={{
          fontSize: '144px',
          cursor: 'pointer',
          width: isExpanded ? '118px' : '48px',
          height: '48px',
          marginTop: '24px',
          marginBottom: '8px',
        }}
      />
    </Toolbar>
  );
};

export default MenuLogo;
